import { render, staticRenderFns } from "./SalesOrderStatusProductId.vue?vue&type=template&id=3db5352f&"
import script from "./SalesOrderStatusProductId.vue?vue&type=script&lang=js&"
export * from "./SalesOrderStatusProductId.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderStatusProductId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports